module.exports = __webpack_public_path__ + "static/img/share_title1.f57bd88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sharedHome/share_title1.png
// module id = ynEx
// module chunks = 1